import dayjs from "dayjs";
import "dayjs/locale/sk"; // load on demand
import striptags from "striptags";
import Countdown from "react-countdown";
import styles from "components/campaign/card/CampaignCard.module.scss";

import dynamic from "next/dynamic";
import { Typography } from "antd";
import { countdownRenderer } from "utils";
const Link = dynamic(() => import("next/link"));
const Image = dynamic(() =>
  import("grandus-lib/components-atomic/image/Image")
);

const CampaignCard = ({
  name,
  urlName,
  availableToTime,
  photo,
  description,
}) => {
  return (
    <div className={styles.card}>
      <Link href="/akcie/[campaign]/[[...parameters]]" as={`/akcie/${urlName}`}>
        <a className={`col-12 col-sm-5 ${styles?.left}`}>
          <Image photo={photo} size={"300x300__cropped"} type={"jpg"} />
        </a>
      </Link>
      <div className={`col-12 col-sm-7 ${styles?.right}`}>
        <Link
          href="/akcie/[campaign]/[[...parameters]]"
          as={`/akcie/${urlName}`}
        >
          <a>
            <h2>{name}</h2>
          </a>
        </Link>
        {availableToTime ? (
          <Countdown
            date={dayjs(availableToTime)}
            renderer={countdownRenderer(styles)}
          />
        ) : null}

        {description ? (
          <Typography.Paragraph ellipsis={{ rows: 3 }}>
            <div dangerouslySetInnerHTML={{ __html: striptags(description) }} />
          </Typography.Paragraph>
        ) : null}

        <Link
          href="/akcie/[campaign]/[[...parameters]]"
          as={`/akcie/${urlName}`}
        >
          <a className="button">Zobraziť detail akcie</a>
        </Link>
      </div>
    </div>
  );
};

export default CampaignCard;
